<template>
  <GraphContainer />
</template>

<script>
import GraphContainer from "./GraphContainer.vue";
export default {
  name: "StudentChatGraph",
  components: { GraphContainer },
  props: { msg: String }
};
</script>

<style scoped></style>
